export default __webpack_public_path__ + "static/media/photo_gallery_4.799e5f53.png";